import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { DialogModule } from 'primeng/dialog';
import { TooltipModule } from 'primeng/tooltip';
import { ComumModule } from '../../../shared/comum.module';
import { translateLoaderNBS } from '../../../shared/translate-loader/translateLoader';
import { TipoEventoService } from './tipo-evento-service/tipo-evento.service';
import { TipoEventoComponent } from './tipo-evento.component';

@NgModule({
  imports: [
    HttpModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    ComumModule,
    TooltipModule,
    DialogModule,
    TranslateModule.forRoot(translateLoaderNBS)
  ],
  exports: [
    TipoEventoComponent
  ],
  declarations: [
    TipoEventoComponent
  ],
  providers: [
    TipoEventoService
  ]
})
export class TipoEventoModule { }



